module.exports = __webpack_public_path__ + "static/media/bingo.1ab64cb2.svg";